<section class="container-fluid">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formEnterprise">
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col-lg-6 col-12 pe-2">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                  <app-custom-input-text formControlName="discountAccount"
                    [labelText]="'Cuenta Descuento'"></app-custom-input-text>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                  <app-custom-input-text formControlName="utilizationAccount"
                    [labelText]="'Cuenta Aprovechamiento'"></app-custom-input-text>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                  <app-custom-input-text formControlName="refundAccount"
                    [labelText]="'Cuenta Reembolso'"></app-custom-input-text>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                  <app-custom-input-text formControlName="interestAccount"
                    [labelText]="'Cuenta Interés'"></app-custom-input-text>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                  <app-custom-input-text formControlName="commissionAccount"
                    [labelText]="'Cuenta Comisión'"></app-custom-input-text>
                </div>
                <hr class="mb-2 mt-3">
                <b class="label">Facturas</b>
                <div class="col-lg-12 col-md-12 col-12">
                  <app-custom-textarea formControlName="invoiceText" [labelText]="'Texto Encabezado Fra.1'"
                    [autoResize]="false" [rows]="1"></app-custom-textarea>
                </div>
                <div class="col-lg-12 col-md-12 col-12">
                  <app-custom-textarea formControlName="invoiceText2" [labelText]="'Texto Encabezado Fra.2'"
                    [autoResize]="false" [rows]="1"></app-custom-textarea>
                </div>
                <div class="col-lg-12 col-md-12 col-12">
                  <app-custom-textarea formControlName="invoiceText3" [labelText]="'Texto Encabezado Fra.3'"
                    [autoResize]="false" [rows]="1"></app-custom-textarea>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-12 ps-2">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12">
                  <app-custom-textarea formControlName="invoiceText4" [labelText]="'Texto Encabezado Fra.4'"
                    [autoResize]="false" [rows]="1"></app-custom-textarea>
                </div>
                <div class="col-lg-12 col-md-12 col-12">
                  <app-custom-textarea formControlName="invoiceText5" [labelText]="'Texto Encabezado Fra.5'"
                    [autoResize]="false" [rows]="1"></app-custom-textarea>
                </div>
                <div class="col-lg-12 col-md-12 col-12">
                  <app-custom-textarea formControlName="invoiceText6" [labelText]="'Texto Encabezado Fra.6'"
                    [autoResize]="false" [rows]="1"></app-custom-textarea>
                </div>
                <div class="col-lg-12 col-md-12 col-12">
                  <app-custom-textarea formControlName="invoiceObservation" [labelText]="'Observación Fra.'"
                    [autoResize]="false" [rows]="1"></app-custom-textarea>
                </div>
                <div class="col-lg-12 col-md-12 col-12">
                  <app-custom-textarea formControlName="invoiceObservation2" [labelText]="'Observación Fra.2'"
                    [autoResize]="false" [rows]="1"></app-custom-textarea>
                </div>
                <div class="col-lg-12 col-md-12 col-12">
                  <app-custom-textarea formControlName="invoiceObservation3" [labelText]="'Observación Fra.3'"
                    [autoResize]="false" [rows]="1"></app-custom-textarea>
                </div>
                <div class="col-lg-12 col-md-12 col-12">
                  <app-custom-textarea formControlName="invoiceObservationFooter"
                    [labelText]="'Observación Footer Fra.'" [autoResize]="false" [rows]="1"></app-custom-textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="col-lg-12 col-md-12 col-12">
      <div class="row">
        <div class="col field-buttons">
          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
            [disabled]="disabledForm" (onClick)="send()">
          </app-custom-button>
        </div>
      </div>
    </div>
  </div>
</section>